module.exports = __webpack_public_path__ + "img/20211224_Christmas_airdrop.364dc97d.jpg";